import type { ReactNode } from 'react';
import { cn } from '@/utils/classnames';

export interface FlowStepProps {
  /** Numeric step indicator (1-based). */
  index: number;
  title: string;
  description: ReactNode;
  /** Whether this is the last step (suppresses the trailing dotted connector). */
  last?: boolean;
}

/**
 * One step in a vertical authorization-code flow diagram (used on the OIDC page).
 */
export function FlowStep({ index, title, description, last = false }: FlowStepProps) {
  return (
    <div className="relative flex gap-stack-md">
      <div className="flex flex-col items-center">
        <div
          className={cn(
            'flex h-8 w-8 items-center justify-center rounded-full',
            'bg-primary-container text-on-primary font-label-caps text-label-caps',
          )}
        >
          {index}
        </div>
        {last ? null : (
          <div
            className="mt-unit w-px flex-1 border-l border-dashed border-outline-variant"
            aria-hidden
          />
        )}
      </div>
      <div className={cn('flex-1 pb-stack-md', last ? 'pb-0' : '')}>
        <h4 className="font-headline-md text-headline-md text-on-surface">{title}</h4>
        <p className="mt-unit text-body-sm text-on-surface-variant">{description}</p>
      </div>
    </div>
  );
}
